import configDefault from './config/default';
import configBaurde from './config/baurde';
import configImwalkingde from './config/imwalkingde';
import configQuellede from './config/quellede';
import configQuellech from './config/quellech';
import configQuelleat from './config/quelleat';
import configOttoversandat from './config/ottoversandat';
import configUniversalat from './config/universalat';
import configAckermannch from './config/ackermannch';
import configJelmolich from './config/jelmolich';
var tenantComponentConfig = {
    emma: configDefault,
    baurde: configBaurde,
    imwalkingde: configImwalkingde,
    quellede: configQuellede,
    quellech: configQuellech,
    quelleat: configQuelleat,
    ottoversandat: configOttoversandat,
    universalat: configUniversalat,
    ackermannch: configAckermannch,
    jelmolich: configJelmolich,
};
var componentConfig = function (_a) {
    var _b = _a.companyId, companyId = _b === void 0 ? 'emma' : _b;
    return tenantComponentConfig["" + companyId] || configDefault;
};
export default componentConfig;
//# sourceMappingURL=index.js.map